<template>
  <!-- ▼Main Container -->
  <div class="boss-main-container">
    <div class="boss-main-wrap boss-main-content-wrap">
      <setting-header
        :breadcrumbs="[{ name: '各種設定' }]"
        title="パスワード変更"
      />
      <div class="grid-x align-justify">
        <div class="medium-6 cell">
          <p>下記の項目を入力してください。</p>
        </div>
      </div>
      <form-item
        v-model="currentPassword"
        label="旧パスワード"
        type="password"
        data-test="current-password"
      />
      <form-item
        v-model="newPassword"
        label="新パスワード"
        type="password"
        :class-name="(isInvalidPassword || isSameCurrentAndNewPassword) ? 'is-invalid-input': ''"
        data-test="new-password"
      >
        <template #error>
          <validation-label
            v-if="isInvalidPassword"
            label="半角英数混在8文字以上20文字以内で入力してください。"
            data-test="new-password-validation"
          />
          <validation-label
            v-if="isSameCurrentAndNewPassword"
            label="現在のパスワードと異なるものを入力してください。"
            data-test="is-same-current-and-new-password"
          />
        </template>
      </form-item>
      <form-item
        v-model="confirmNewPassword"
        label="新パスワード (確認用)"
        type="password"
        :class-name="isDifferentNewPassword ? 'is-invalid-input': ''"
        data-test="confirm-new-password"
      >
        <template #error>
          <validation-label
            v-if="isDifferentNewPassword"
            label="新パスワードと新パスワード(確認用)が一致しません。"
            data-test="is-same-new-password-confirm"
          />
        </template>
      </form-item>
      <form-button-area>
        <form-confirm-button
          :is-disabled="isDisable"
          submit-label="パスワードを変更する"
          data-test="confirm-button"
          @submit-event="changePassword"
        />
      </form-button-area>
    </div>
  </div>
  <!-- ▲Main Container -->
</template>

<script>
import SettingHeader from '@/components/atoms/SettingHeader'
import FormItem from '@/components/atoms/FormItem'
import ValidationLabel from '@/components/atoms/ValidationLabel'
import FormButtonArea from '@/components/atoms/FormButtonArea'
import FormConfirmButton from '@/components/atoms/FormConfirmButton'
import _ from 'lodash'

export default {
  components: {
    SettingHeader,
    FormItem,
    ValidationLabel,
    FormButtonArea,
    FormConfirmButton
  },
  data () {
    return {
      currentPassword: '',
      newPassword: '',
      confirmNewPassword: ''
    }
  },
  computed: {
    isInvalidPassword () {
      // 半角英数混在8文字以上20文字以内のチェック（空の場合は入力チェックをしない）
      return !_.isEmpty(this.newPassword) && !(/^(?=.*?[a-z])(?=.*?\d)[a-z\d]{8,20}$/i).test(this.newPassword)
    },
    isDifferentNewPassword () {
      return !_.isEmpty(this.confirmNewPassword) && this.newPassword !== this.confirmNewPassword
    },
    isSameCurrentAndNewPassword () {
      return !_.isEmpty(this.currentPassword) && this.currentPassword === this.newPassword
    },
    isDisable () {
      return _.isEmpty(this.currentPassword) ||
      _.isEmpty(this.newPassword) ||
      _.isEmpty(this.confirmNewPassword) ||
      this.isInvalidPassword ||
      this.isDifferentNewPassword ||
      this.isSameCurrentAndNewPassword
    }
  },
  methods: {
    changePassword () {
      this.$http.secured.put('/settings/change_password', {
        currentPassword: this.currentPassword,
        newPassword: this.newPassword
      }).then(
        response => {
          this.$toasted.global.success({ message: 'パスワードを変更しました。' })
        }
      )
    }
  }
}
</script>
